module.exports = __webpack_public_path__ + "media/images/quick_search/format/img_2-b1529fc548afca156946c2299f2d41d3.png";